import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';
import { call, select, takeLatest } from 'redux-saga/effects';
import { fetchQuery } from 'relay-runtime';
import { createAsyncAction, getType } from 'typesafe-actions';
import { LoggerStatusEnum, sendLog } from 'ui-model';

import { selectAuthUser } from '@lib/selectors';
import environment from '@lib/utils/RelayEnvironment';

export const actionUpdateProvider = createAsyncAction(
  'actionUpdateProvider/REQUEST',
  'actionUpdateProvider/SUCCESS',
  'actionUpdateProvider/FAILURE',
)<any, any, any>();

const query = graphql`
  query sagaWatchersProviderQuery($id: MongoID!) {
    providerById(_id: $id) {
      _id
      name
      oid_avatar
      setting {
        settings {
          reminder {
            enabled
          }
          cancellation {
            enabled
          }
          telehealth {
            enabled
          }
          followup {
            enabled
          }
          feedback {
            enabled
          }
          referral {
            enabled
          }
          scheduler {
            enabled
          }
        }
      }
    }
  }
`;

function* sagaWatcherUpdateProvider(data: any) {
  try {
    const providerId = get(data, '_id', get(data, 'payload.requestPayload._id', get(data, 'payload.data._id', '')));
    const viewerId: string = yield select(selectAuthUser);
    if (providerId && providerId !== viewerId) {
      yield call(fetchQuery, environment, query, { id: providerId });
    } else {
      sendLog('sagaWatchersProvider#sagaWatcherUpdateProvider _id not found', { data }, LoggerStatusEnum.error);
    }
  } catch (error) {
    sendLog('sagaWatchersProvider#sagaWatcherUpdateProvider', { error }, LoggerStatusEnum.error);
  }
}

export default function* sagaWatchersProvider() {
  yield takeLatest(getType(actionUpdateProvider.success), sagaWatcherUpdateProvider);
}
